module API.Util
  ( MkClientOpts
  , mkClient
  ) where

import Prelude

import Affjax (Request, printError)
import Affjax.RequestBody as Req
import Affjax.RequestHeader (RequestHeader(..))
import Affjax.ResponseFormat (json)
import Affjax.StatusCode (StatusCode(..))
import Affjax.Web (defaultRequest)
import Affjax.Web as Affjax
import Control.Monad.Except (runExceptT, throwError)
import Data.Argonaut (Json)
import Data.Array (catMaybes)
import Data.BasicURL (BasicURL)
import Data.BasicURL as BasicUrl
import Data.Codec.Argonaut (JsonDecodeError)
import Data.Either (Either(..))
import Data.HTTP.Method (Method)
import Data.Maybe (Maybe, fromMaybe)
import Effect.Aff (Aff)
import Visonum.BulkPingApp.Util (liftAffErr, liftEitherErr)

type MkClientOpts query body response =
  { baseUrl :: BasicURL
  , method :: Method
  , path :: String
  , token :: Maybe String
  , query :: Maybe query
  , body :: Maybe body
  , encodeBody :: body -> Json
  , decodeResponse :: Json -> Either JsonDecodeError response
  , encodeQuery :: query -> String
  }

mkClient
  :: forall query body response
   . MkClientOpts query body response
  -> Aff (Either String response)
mkClient opts = runExceptT do
  result <- Affjax.request req
    # liftAffErr printError

  unless (result.status == StatusCode 200) do
    throwError ("Request failed with status: " <> show result.status)

  val <- opts.decodeResponse result.body
    # liftEitherErr show

  pure val
  where
  mayQueryEncoded :: Maybe String
  mayQueryEncoded = map opts.encodeQuery opts.query

  mayBodyEncoded :: Maybe Req.RequestBody
  mayBodyEncoded = map (Req.json <<< opts.encodeBody) opts.body

  fullUrl :: String
  fullUrl = BasicUrl.print opts.baseUrl <> "/" <> opts.path <> "/" <> fromMaybe "" mayQueryEncoded

  headers :: Array (Maybe RequestHeader)
  headers =
    [ map (\tok -> RequestHeader "Authorization" ("Bearer " <> tok)) opts.token
    ]

  req :: Request Json
  req = defaultRequest
    { responseFormat = json
    , method = Left opts.method
    , url = fullUrl
    , content = mayBodyEncoded
    , headers = catMaybes headers
    }

